import React from 'react';
import PlaceholderPage from '../../components/PlaceholderPage';

const Machines = () => <PlaceholderPage title="장비 관리" description="세탁 장비 상태를 확인해요." />;

export default Machines;
